<script setup lang="ts">
import translaters from "@/tradutors/assineTitleUpgrade";
import { isMobile} from "@/shared/utils/mobile";

const storePlan = planStore();
const route = useRoute();

const reactiveLocale = computed(() => route.params.language); // Certifique-se de que locale é uma ref

const saldoUpgrade = computed(() => storePlan.saldoUpgrade);

const translate = computed(() => {
  if (reactiveLocale.value === "pt-br") {
    return translaters.portugues;
  } else {
    return translaters.ingles;
  }
});

const formatCurrency = () => {
  return `${
    reactiveLocale.value == "pt-br" ? "R$" : "$"
  } ${saldoUpgrade.value.replace(".", ",")}`;
};

const props = defineProps({
  order: {
    type: Object || Boolean,
    required: false,
  },
});
</script>
<template>
  <div class="container mt-4" v-if="Number(saldoUpgrade) > 0">
    <div class="row">
      <div v-if="order && order.plan_type_name != 'Gold'" class="col-lg-12 col-12 d-flex justify-content-center">
        <span class="title-upgrade-order">
          {{ translate.subtitleOrder1 }}
          <br v-if="isMobile()" />
          <strong class="title-bold">{{ order.plan_name }}</strong>
          <br v-if="isMobile()" />
          {{ translate.subtitleOrder2 }}
          <strong class="title-bold">{{ order.finish }}</strong
          >.
        </span>
      </div>
      <div v-if="order && order.plan_type_name != 'Gold'">
        <div class="col-lg-12 col-12 d-flex justify-content-center">
          <span class="subtitle-upgrade"
            >{{ translate.subtitle1 }} ({{ formatCurrency() }})<br>
            {{ translate.subtitle2 }}</span
          >
        </div>
        <div class="col-lg-12 col-12 d-flex justify-content-center">
          <span class="title-upgrade-order-1">{{ translate.subtitle3 }}</span>
        </div>
        <div class="col-lg-12 col-12 d-flex justify-content-center">
          <span class="title-upgrade-order-1">{{ translate.subtitle4 }}</span>
        </div>
      </div>
      <div v-else class="col-lg-12 col-12 justify-content-center">
        <div class="subtitle-upgrade-1 mb-3">{{ translate.subtitle5 }}</div>
        <div class="subtitle-upgrade">{{ translate.subtitle6 }}</div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="css">
.title-upgrade {
  font-family: "Exo-2";
  font-weight: 500;
  font-size: 30px;
  line-height: 41px;
  letter-spacing: 0%;
  text-align: center;
  color: #5b5858;
}
.subtitle-upgrade {
  font-family: "Roboto-Regular";
  font-weight: 700;
  font-size: 25px;
  line-height: 35px;
  letter-spacing: 0%;
  text-align: center;
  color: #ff6000;
  margin-bottom: 20px;
}

.subtitle-upgrade-1 {
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 50px;
  line-height: 41px;
  letter-spacing: 0%;
  text-align: center;
  color: #585858;
}

.title-upgrade-order {
  font-size: 20px;
  line-height: 31px;
}

.title-upgrade-order-1 {
  font-size: 15px;
  line-height: 20px;
  opacity: 0.5;
}

.title-bold {
  font-size: 22px;
}

/* regras mobile/tablet até 970px: este título aparece dentro do carrossel de
   planos (logado com saldo), que vai até 970px na index e na Minha Conta. */
@media screen and (max-width: 970px) {
  .title-upgrade-order {
    font-size: 17px;
    text-align: center;
    line-height: 1.2;
  }
  .title-upgrade-order-1 {
    text-align: center;
  }
  .subtitle-upgrade {
    font-size: 18px;
    line-height: 25px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .title-bold {
    font-size: 18px;
  }

}

/* ===== Tema Gold (aba Renovar/Upgrade da Minha Conta) ===== */
/* A classe .gold-theme vem da raiz do NavBarAccount — em /assine ela não
   existe, então nada aqui muda naquela página. */
.gold-theme .subtitle-upgrade {
  color: #e9c554;
}

.gold-theme .title-upgrade,
.gold-theme .subtitle-upgrade-1 {
  color: #ffffff;
}
</style>
